import type fr from '../fr/public';

const en: typeof fr = {
  title: 'Home',
  nav: { myAccount: 'My account' },
  hero: {
    eyebrow: 'South Shore and Montreal',
    title: 'A clean home, without thinking about it.',
    subtitle: 'Residential and commercial cleaning by a stable, insured and caring team. Book in two minutes, follow everything from your phone.',
    cta: 'Request a quote',
    secondary: 'I already have an account',
  },
  services: {
    title: 'Our services',
    standard: { title: 'Regular cleaning', text: 'Weekly, every two weeks or monthly, with the same team.' },
    deep: { title: 'Deep cleaning', text: 'Grout, baseboards, under furniture: a real spring cleaning.' },
    move: { title: 'Move in / out', text: 'Empty home cleaned top to bottom, cabinets and appliances included.' },
    commercial: { title: 'Commercial', text: 'Offices, clinics and shops, outside your opening hours.' },
  },
  how: {
    title: 'How it works',
    s1: { title: 'Describe your property', text: 'Rooms, pets, preferences: only once.' },
    s2: { title: 'Get your price', text: 'Our team confirms a clear price, no surprises.' },
    s3: { title: 'Accept and you are done', text: 'Your team arrives on time, you follow everything online.' },
  },
  benefits: {
    title: 'Why choose us',
    b1: 'The same team at every visit',
    b2: 'Automatic reminder before each cleaning',
    b3: 'Change or cancel online',
    b4: 'Trained, insured and well-paid employees',
  },
  estimate: {
    title: 'Estimate your cleaning',
    subtitle: 'An indicative range. The official price is confirmed by our team.',
    service: 'Cleaning type',
    propertyType: 'Property type',
    bedrooms: 'Bedrooms',
    bathrooms: 'Bathrooms',
    floors: 'Floors',
    frequency: 'Frequency',
    pets: 'Pets at home',
    compute: 'See the estimate',
    result: 'Between {{low}} and {{high}}',
    duration: 'Estimated duration: {{duration}}',
    book: 'Book with this indicative price',
  },
  footer: { rights: 'All rights reserved.', contact: 'Contact us' },
  login: {
    title: 'Sign in',
    subtitle: 'Access your account.',
    email: 'Email',
    password: 'Password',
    submit: 'Sign in',
    noAccount: 'No account yet?',
    demoTitle: 'Demo accounts',
    demoHint: 'Password: demo1234',
    welcome: 'Welcome back!',
    welcomeText: 'Log in to follow your cleanings.',
    forgot: 'Forgot password?',
    or: 'or',
    createAccount: 'Create an account',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    staffHint: 'Employee or manager? Use the same form.',
    sideTitle: 'A calmer home, every day.',
    b1: 'Your appointments at a glance',
    b2: 'Changes online',
    b3: 'Messages with our team',
    b4: 'Instructions kept and secured',
  },
  register: {
    title: 'Create my account',
    subtitle: 'To book and follow your cleanings.',
    fullName: 'Full name',
    phone: 'Phone',
    password: 'Password (8 characters minimum)',
    submit: 'Create my account',
    hasAccount: 'Already have an account?',
    consent: 'I accept the <terms>terms of use</terms> and the <privacy>privacy policy</privacy>.',
    consentRequired: 'Please accept the terms to create your account.',
    quoteKept: 'Your quote answers are kept: you will find them in the next step.',
  },
  checkout: {
    title: 'Secure payment (simulation)',
    subtitle: 'Local mode: no card is requested or stored. Choose the outcome to simulate.',
    pay: 'Pay {{amount}}',
    fail: 'Simulate a decline',
    success: 'Payment received. Thank you!',
    failed: 'The payment was declined (simulation).',
    back: 'Back to my payments',
  },
  notFound: { title: 'Page not found', text: 'The link may be wrong or the page has moved.', home: 'Back to home' },
};
export default en;
